import Banner from "./Banner";
import Hero from "./Hero";
import Promo from "./Promo";
import Stack from "./Stack";
import Benefits from "./Benefits";
import wrapperClasses from "../../commons/Wrapper.module.scss";
import Footer from "./Footer";
export default function Shapely() {
  return (
    <section className={wrapperClasses.section}>
      <Hero />
      <Banner />
      <Stack />
      <Benefits />
      <Promo />
      <Footer />
    </section>
  );
}
